module.exports = __webpack_public_path__ + "img/banner-img2.3c7cbb30.png";